import users from 'modules/core/store/collections/users'

import { getPermissionVerbs } from 'modules/reviews/lib/getPermissionVerbs'

export const canCreateReviews = (): boolean => {
  const verbs = getPermissionVerbs()
  const verbType = verbs.forms?.permission

  return verbType ? users.current.policy.can(verbType) : false
}
